import { Link } from "react-router-dom";
function Library() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active">Library</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3">
          <div class="col-lg-12">
            <h1> Library </h1>
            <p>
              A library is a resource-rich learning space that provides access
              to books, journals, digital materials, and reference services,
              offering students a quiet environment for reading, research, and
              study while supporting academic growth through organized
              collections, information guidance, and opportunities for
              independent learning.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Library_1.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Library_2.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Library_3.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Library_4.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Library;
